/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Resources_Faq_EmptyInputs */

const en_localcms_resources_faq_empty = /** @type {(inputs: Localcms_Resources_Faq_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No FAQs available yet`)
};

/**
* | output |
* | --- |
* | "No FAQs available yet" |
*
* @param {Localcms_Resources_Faq_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_resources_faq_empty = /** @type {((inputs?: Localcms_Resources_Faq_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Resources_Faq_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_resources_faq_empty(inputs)
});